import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import { task } from 'ember-concurrency';
import type { LookerScheduledPlan } from 'lumen/models';

export default class MarketCustomReportingScheduledReportsRoute extends Route {
  @service declare alerting: Services['alerting'];
  @service declare errorTracking: Services['error-tracking'];
  @service declare store: Services['store'];

  loadScheduledReportsTask = task({ restartable: true }, async () => {
    try {
      return await this.store.query<LookerScheduledPlan>(
        'looker-scheduled-plan',
        {
          namespace: 'api/v3',
          typeKey: 'custom-reporting/scheduled-plans',
        },
      );
    } catch (error) {
      this.errorTracking.captureException(error);
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.alerting.showErrorAlert();
      return undefined;
    }
  });

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  model() {
    const model = {
      reports: this.loadScheduledReportsTask,
    };

    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    model.reports.perform();

    return model;
  }
}
